import React from 'react';
import { Feature } from '@tencent/workbench';
import type { NumberInputFrom } from '@tencent/wb-ext-form';
import BaseDrawerEffectFeature from '@framework/workbench/common/feature/base-drawer-effect-feature';
import SoftEdgePresetMenu from '@framework/frame-pc/components/palette-panel/effect-preset-menu/soft-edge-preset-menu';
import { FormItemName, INPUT_PROPS_CALLBACK_KEY } from '@framework/workbench/drawer/constants';
import PresetPanel from '@framework/workbench/drawer/components/preset-panel';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import {
    IElementBaseModel,
} from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { ISoftEdgeModelVal } from '@src/slide/domain/ui-model/element-modeles/property/effect/effect.interface';
import { handleInputBlurInitAndReset } from '@src/slide/application/service/drawer-input-manager/drawer-handler';
import { PresetUtilFactory } from '@src/framework/frame-pc/components/palette-panel/effect-preset-menu/preset-util/preset-util-facotry';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { EMPTY_EFFECT } from '@src/framework/frame-pc/components/palette-panel/effect-preset-menu/preset-util/base-preset-util';
import { ISoftEdgeFeature } from '@tencent/drawing-drawer-components';

const defaultSoftEdgeProps = {
    size: 0,
};

@Feature()
export class SoftEdgeFeature extends BaseDrawerEffectFeature implements ISoftEdgeFeature {
    public softEdgeProps: ISoftEdgeModelVal = { ...defaultSoftEdgeProps };
    public get softEdgeInfo() {
        return (this.getSelectModel() as IMultiplyModel | IElementBaseModel)?.getEffect?.()
            .getSoftEdge() ?? defaultSoftEdgeProps;
    }
    public get isMultiDifferent(): boolean {
        return this.isMultiDiffValue('effect.softEdge');
    }
    public get size() {
        return this.softEdgeProps.size;
    }

    public constructor() {
        super();
        this.addInitPropsCallback(INPUT_PROPS_CALLBACK_KEY.SOFT_EDGE);
    }

    public initPropsCallback = () => {
        this.softEdgeProps = { ...this.softEdgeInfo };
    };

    public renderPreset() {
        const { iconStyle, iconName } = PresetUtilFactory.getPresetUtil(ActionType.SOFTEDGE)
            .getPresetStyle(this.softEdgeInfo);
        return  (<PresetPanel
            src={iconStyle}
            hasEffect={iconName !== EMPTY_EFFECT}
            isMultiDifferent={this.isMultiDifferent}
            onVisibleChange={this.handlePresetVisibleChange}
        >
            <SoftEdgePresetMenu
                preset={{ style: iconName }}
                onSoftEdgePresetStyleClick={
                    softEdgeProps => this.handleSoftEdgePresetStyleClick(softEdgeProps)
                }
                onSoftEdgePresetStyleMouseEnter={
                    softEdgeProps => this.handleSoftEdgePresetSytleEnter(softEdgeProps)
                }
                onSoftEdgePresetStyleMouseLeave={() => this.handleShadowMenuMouseLeave()} />
        </PresetPanel>);
    }

    public updateSoftEdgeProps = (onlyChangeUI?: boolean, onPreview?: boolean) => {
        if (this.checkSelectType() <= 1) {
            this.getAppService().editableServiceLayer?.previewService?.updateElementPreviewState(false);
        }
        (this.getSelectModel() as IMultiplyModel | IElementBaseModel)?.getEffect?.()
            .updateSoftEdge({ ...this.softEdgeProps }, !!onlyChangeUI);
    };

    /**
     * 从‘预设’面板切换不同的阴影类型
     * @param {string} value
     */
    public handleSoftEdgePresetStyleClick = (softEdge) => {
        this.getAppService().editableServiceLayer?.previewService?.updateElementPreviewState(false);
        this.softEdgeProps = { ...defaultSoftEdgeProps, ...softEdge };
        this.updateSoftEdgeProps();
        this.tdwDrawerReport(FormItemName.SOFT_EDGE, { ver5: softEdge ? 2 : 1 });
    };

    public handleSoftEdgePresetSytleEnter = (softEdge) => {
        if (this.checkSelectType() > 1) {
            return;
        }
        (this.getSelectModel() as IMultiplyModel | IElementBaseModel)?.getEffect?.()
            .updateSoftEdge(softEdge, true);
        this.getAppService().editableServiceLayer?.previewService?.updateElementPreviewState(true);
    };

    public handleShadowMenuMouseLeave = () => {
        if (this.checkSelectType() > 1) {
            return;
        }
        const softEdge: ISoftEdgeModelVal = { ...this.softEdgeProps };
        (this.getSelectModel() as IMultiplyModel | IElementBaseModel)?.getEffect?.()
            .updateSoftEdge(softEdge, true);
        this.getAppService().editableServiceLayer?.previewService?.updateElementPreviewState(false);
    };

    @handleInputBlurInitAndReset(INPUT_PROPS_CALLBACK_KEY.SOFT_EDGE)
    public handleSoftEdgeChange(value, dragEnd?: boolean, from?: NumberInputFrom) {
        const sizeObj = this.getValidValue(value, from);
        this.softEdgeProps = { ...this.softEdgeInfo, ...sizeObj };
        const onlyChangeUI = this.isInputOnlyChangeUIWithDrag(dragEnd);
        this.updateSoftEdgeProps(onlyChangeUI);
        this.tdwDrawerReportNumberInput(FormItemName.SOFT_EDGE_SIZE, { ver6: sizeObj.size }, from, onlyChangeUI);
    }

    public handlePresetVisibleChange = (visible: boolean) => {
        if (visible) {
            this.softEdgeProps = { ...this.softEdgeInfo };
        }
    };
}
